import queryString from 'querystring';

export const stringifyQueryParams = (params) => `?${queryString.stringify(params)}`;
